module.exports = __webpack_public_path__ + "static/media/iphone.e0257aac.svg";